<template>
  <div class="custom-divider">
    <div class="shadow"></div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/custom-divider.scss';
</style>
